// extracted by mini-css-extract-plugin
module.exports = {"alarm_close":"modal_alarm_close__1xRmw","alarm_modal":"modal_alarm_modal__2ytjl","alarm_modal_lg":"modal_alarm_modal_lg__ycooN","alarm_modal_bg":"modal_alarm_modal_bg__2mA8y"};